module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-rater"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    staticStyle: {
      "display": "none"
    },
    domProps: {
      "value": (_vm.currentValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentValue = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._l((_vm.max), function(i) {
    return _c('a', {
      staticClass: "vux-rater-box",
      class: {
        'is-active': _vm.currentValue > i - 1
      },
      style: ({
        color: _vm.colors && _vm.colors[i - 1] ? _vm.colors[i - 1] : '#ccc',
        marginRight: _vm.margin + 'px',
        fontSize: _vm.fontSize + 'px',
        width: _vm.fontSize + 'px',
        height: _vm.fontSize + 'px',
        lineHeight: _vm.fontSize + 'px'
      }),
      on: {
        "click": function($event) {
          _vm.handleClick(i - 1)
        }
      }
    }, [_c('span', {
      staticClass: "vux-rater-inner"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.star)
      }
    }), (_vm.cutPercent > 0 && _vm.cutIndex === i - 1) ? _c('span', {
      staticClass: "vux-rater-outer",
      style: ({
        color: _vm.activeColor,
        width: _vm.cutPercent + '%'
      }),
      domProps: {
        "innerHTML": _vm._s(_vm.star)
      }
    }) : _vm._e()])])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a76af5e2"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/rater/index.vue
// module id = 414
// module chunks = 1